// React
import React from 'react';
import {useState} from 'react';

// MUI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Fade from '@mui/material/Fade';
import Divider from '@mui/material/Divider';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

// others

import * as fbproto from '../messages_pb.js';
import { useFetch } from '../hooks/useFetch.jsx';

// TODO: replace all text with images instead
export default function PhConfig(props) {
    const [calibrationState, setCalibrationState] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarError, setSnackbarError] = useState(false);
    const fetchWrapper = useFetch();
    const ERR_UNKNOWN_ERROR = "pH calibration failed."
    const ERR_DEVICE_NOT_CONNECTED = "pH calibration failed. Please connect the pH sensor to the controller."
    const ERR_CONTROLLER_UNREACHABLE = "pH calibration failed. Please check that the controller is connected to wifi."
    
    // enum CalibrationState {
    //  OFF = 0,
    //  BEGIN_CALIBRATION = 1,
    //  CALIBRATING_686 = 2,
    //  CALIBRATED_686 = 3,
    //  CALIBRATING_400 = 4,
    //  CALIBRATION_DONE = 5,
    // }
    
    function beginEndCalibration(e) {
        if (calibrationState > 0) {
            setCalibrationState(0);
        }
        else {
            setCalibrationState(1);
        }
    }
    
    function calibrate686(e) {
        if (calibrationState !== 1) {
            return
        }
        
        const calibratePhBody = {
            deviceId: props.device.deviceId,
            controllerId: props.controllerId,
            phValue: 6.86
        }
        setCalibrationState(2);
        fetchWrapper.post(`https://api.${process.env.REACT_APP_DOMAIN}/devices/calibrateph`, calibratePhBody)
            .then(response => {
                if (response.ok)
                    return response.json();
                else if (response.status === 504)
                    throw new Error(ERR_CONTROLLER_UNREACHABLE);
                else
                    return response.json();
            })
            .then(responseObj => {
                console.log("calibrateph body = " + JSON.stringify(responseObj));
                // sample response: {"device":{"deviceId":5, "controllerId":3}, "error":0}
                if (responseObj.error === 0) {
                    setCalibrationState(3);
                }
                else if (responseObj.error === fbproto.Error.ERROR_DEVICE_NOT_CONNECTED) {
                    throw new Error(ERR_DEVICE_NOT_CONNECTED + " (" + responseObj.error + ")");
                }
                else {
                    throw new Error(ERR_UNKNOWN_ERROR + " (" + responseObj.error + ")");
                }
            })
            .catch(error => {
                console.log("error = " + JSON.stringify(error));
                setCalibrationState(1);
                setSnackbarOpen(true);
                setSnackbarError(error.message);
            });
    }
    
    function calibrate400(e) {
        if (calibrationState !== 3) {
            return;
        }

        const calibratePhBody = {
            deviceId: props.device.deviceId,
            controllerId: props.controllerId,
            phValue: 4.00
        }
        setCalibrationState(4);
        fetchWrapper.post(`https://api.${process.env.REACT_APP_DOMAIN}/devices/calibrateph`, calibratePhBody)
            .then(response => {
                if (response.ok)
                    return response.json();
                else if (response.status === 504)
                    throw new Error(ERR_CONTROLLER_UNREACHABLE);
                else
                    return response.json();
            })
            .then(responseObj => {
                console.log("calibrateph body = " + JSON.stringify(responseObj));
                // sample response: {"device":{"deviceId":5, "controllerId":3}, "error":0}
                if (responseObj.error === 0) {
                    setCalibrationState(5);
                }
                else if (responseObj.error === fbproto.Error.ERROR_DEVICE_NOT_CONNECTED) {
                    throw new Error(ERR_DEVICE_NOT_CONNECTED + " (" + responseObj.error + ")");
                }
                else {
                    throw new Error(ERR_UNKNOWN_ERROR + " (" + responseObj.error + ")");
                }
            })
            .catch(error => {
                console.log("error = " + JSON.stringify(error));
                setCalibrationState(3);
                setSnackbarOpen(true);
                setSnackbarError(error.message);
            });
    }
    
    function calibrationDone(e) {
        if (calibrationState === 5)
            setCalibrationState(0);
    }
    
    function handleSnackbarClose(event, reason) {
        // if (reason === 'clickaway')
        //     return;
        // else
        //     setSnackbarOpen(false);
        setSnackbarOpen(false);
    }

    return (
        <Box sx={{padding:2}}>
            
            <Box sx={{padding:2}}>
                <Typography align='left'>To calibrate your sensor, first prepare the following items:</Typography>
                <List align='left' sx={{paddingTop:0, paddingLeft:5, listStyleType: 'disc'}}>
                    <ListItem sx={{display:'list-item'}}>Distilled water, 1L</ListItem>
                    <ListItem sx={{display:'list-item'}}>pH calibration packets, pH6.86 and pH4.00</ListItem>
                    <ListItem sx={{display:'list-item'}}>3 containers, at least 300ml each</ListItem>
                </List>
                <Divider />
                <Typography align='left' sx={{paddingTop:2}}>Click the button below once you are ready to begin</Typography>
            </Box>
            
            {/*  */}
            <Button disabled={calibrationState >= 2 && calibrationState !== 3} size="small" variant="contained" onClick={beginEndCalibration}>
                {calibrationState >= 1 ? "Cancel calibration" : "Calibrate pH sensor"}
            </Button>
            
            <Box sx={{padding:2}}>
                <Fade in={calibrationState>=1}>
                    <List align='left'>
                        <ListItem><ListItemText primary="Pour 250ml distilled water into each of the 3 containers."/></ListItem>
                        <ListItem><ListItemText primary="Pour the pH6.86 buffer powder into container A and mix well."/></ListItem>
                        <ListItem><ListItemText primary="Pour the pH4.00 buffer powder into container B and mix well."/></ListItem>
                        <ListItem><ListItemText primary="The third container C is to clean the pH sensor."/></ListItem>
                        <ListItem><ListItemText primary="Wash the pH sensor in container C."/></ListItem>
                        <ListItem><ListItemText primary="Dry the pH sensor, then place it in container A."/></ListItem>
                        <ListItem secondaryAction={
                            calibrationState === 1 || calibrationState === 2 ?
                            <LoadingButton size="small" loading={calibrationState===2} variant="contained" onClick={calibrate686}>Done</LoadingButton> : null }>
                            <ListItemText primary="Wait for 1 minute, then click Done."/>
                        </ListItem>
                        <Divider />
                    </List>
                </Fade>
                <Fade in={calibrationState>=3}>
                    <List align='left'>
                        <ListItem><ListItemText primary="Remove the pH sensor from container A and rinse it in container C."/></ListItem>
                        <ListItem><ListItemText primary="Dry the pH sensor, then place it in container B."/></ListItem>
                        <ListItem secondaryAction={
                            calibrationState === 3 || calibrationState === 4 ?
                            <LoadingButton size="small" loading={calibrationState===4} variant="contained" onClick={calibrate400}>Done</LoadingButton> : null }>
                            <ListItemText primary="Wait for 1 minute, then click Done."/>
                        </ListItem>
                        <Divider />
                    </List>
                </Fade>
                <Fade in={calibrationState>=5}>
                    <List align='left'>
                        <ListItem><ListItemText primary="Remove the pH sensor from container B, rinse it in container C and dry it."/></ListItem>
                        <ListItem secondaryAction={calibrationState === 5 ? <LoadingButton size="small" variant="contained" onClick={calibrationDone}>Done</LoadingButton> : null}>
                            <ListItemText primary="You are done! Your pH sensor is ready to go!"/>
                        </ListItem>
                    </List>
                </Fade>
            </Box>
            <Snackbar open={snackbarOpen} onClose={handleSnackbarClose}>
                <Alert severity="error" variant="outlined" sx={{ width: '100%', bgcolor: 'background.paper' }} >
                    {snackbarError}
                </Alert>
            </Snackbar>

        </Box>
    )
};

